import { jsx as m } from "react/jsx-runtime";
import { useMemo as u } from "react";
import { ComponentToggleContext as d } from "./context.js";
function p({
  flags: o,
  importFn: r,
  maxFeatureDepth: e,
  children: t
}) {
  if (!r)
    throw new Error("importFn is required");
  const n = u(
    () => ({
      flags: o,
      importFn: r,
      maxFeatureDepth: e,
      isEnabled: (i) => o[i] ?? !1
    }),
    [o, r, e]
  );
  return /* @__PURE__ */ m(d.Provider, { value: n, children: t });
}
export {
  p as ComponentToggleProvider,
  p as default
};
